<template>
  <v-container>
    <v-expansion-panels v-model="panels" focusable multiple popup>
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple>
          Общая информация
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col :cols="12">
              <v-text-field
                label="Наименование технологии"
                v-model="name"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                :error-messages="nameErrors"
              />

              <v-select
                label="Область примененения"
                v-model="application"
                :items="dict100"
                multiple
                chips
                item-value="code"
                item-text="value"
                @input="$v.application.$touch()"
                @blur="$v.application.$touch()"
                :error-messages="applicationErrors"
              />
              <v-textarea
                label="Источник информации о ИТЗ"
                v-model="infoSource"
                rows="1"
                auto-grow
              />

              <v-select
                label="Год создания ИТЗ"
                v-model="creationYear"
                :items="year"
              />

              <v-textarea
                label="Краткое описание функционала"
                v-model="description"
                rows="1"
                auto-grow
              />

              <attached-files
                label="Загружаемые данные"
                fieldName="infoSourceFiles"
                :cardId="id"
                :uNumber="uNumber"
              />

              <v-select
                label="Характер технологии (преимущественный)"
                v-model="technologyCharacter"
                :items="technologyCharacters"
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Уровни и условия оказания медицинской помощи"
                v-model="levels"
                :items="dict26"
                multiple
                chips
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Уровень технологической зрелости"
                v-model="maturityLevel"
                :items="maturityLevels"
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Healthcare классификатор"
                v-model="healthcareClassifier"
                :items="hsClassifier"
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Основной профиль (соц/мед)"
                v-model="profiles"
                :items="dict4"
                multiple
                chips
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Дисциплинарная направленность"
                v-model="subjectOrientations"
                :items="dict28"
                multiple
                chips
                item-value="code"
                item-text="value"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple color="teal lighten-5">
          Соответствие национальным и отраслевым целям/задачам
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <v-row no-gutters> -->
          <!-- <v-col :cols="expertModeCols"> -->
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <div class="text-subtitle-1">
                Нормативно - правовое обоснование
              </div>
              <v-treeview
                v-model="laws"
                :items="dict7"
                item-key="code"
                item-text="value"
                selectable
                dense
              >
                <template v-slot:label="{ item }">
                  <v-tooltip bottom max-width="800">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.value }}</span>
                    </template>
                    <span>{{ item.value }}</span>
                  </v-tooltip>
                </template>
              </v-treeview>
            </v-col>
            <v-divider v-if="expert" vertical class="ma-4"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="end">
              <the-laws-score></the-laws-score>
            </v-col>
          </v-row>

          <v-divider />
          <v-select
            label="Управляющая здоровьесберегательная направленность ИТЗ"
            v-model="controlOrientation"
            :items="dict6"
            item-value="code"
            item-text="value"
            chips
            multiple
          />

          <!-- <div class="text-subtitle-1">Факторная направленность</div>
          <v-treeview
            v-model="factorOrientation"
            :items="dict5"
            item-key="code"
            item-text="value"
            selectable
            dense
          >
            <template v-slot:label="{ item }">
              {{ formatTree(5, item.code) }}
            </template>
          </v-treeview> -->

          <v-select
            label="Факторная направленность"
            v-model="factorOrientation"
            :items="dict5"
            item-value="code"
            item-text="value"
            chips
            multiple
          />

          <v-divider></v-divider>

          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Целевые показатели"
                v-model="target"
                :items="dict8"
                item-value="code"
                item-text="value"
                chips
                multiple
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-4"></v-divider>

            <v-col v-if="expert" :class="expertModeColor" align-self="end">
              <the-target-score></the-target-score>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple color="teal lighten-4">
          Критерии инновационной сутевой основы (раздел 1)
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Правовая основа результатов НИР"
                v-model="legalProtection"
                :items="dict14"
                multiple
                chips
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="center">
              <the-legal-protection-score></the-legal-protection-score>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Объем финансирования НИР"
                v-model="financing"
                :items="dict101"
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="center">
              <the-financing-score></the-financing-score>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Период инвестиций"
                v-model="investmentPeriod"
                :items="dict103"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Количество высококвалифицированных разработчиков"
                v-model="developers"
                :items="dict102"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Награды за ИТЗ"
                v-model="rewards"
                :items="dict17"
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="center">
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Новизна"
                v-model="priority"
                :items="dict19"
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="center">
              <the-priority-score></the-priority-score>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Новые специальности/повышение квалификации"
                v-model="personnel"
                :items="dict20"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Новые потребительские характеристики ИТЗ"
                v-model="specifications"
                :items="dict21"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Новые расходные материалы и/или лекарственные средства"
                v-model="consumables"
                :items="dict22"
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="end">
              <the-chapter-one-score></the-chapter-one-score>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple color="teal lighten-3">
          Критерии производственной интеграции (раздел 2)
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-text-field
                label="Стоимость владения (приблизительно порядок в год)"
                v-model="hstCost"
              />
              <v-text-field
                label="Стоимостная оценка необходимой материально-технической базы (доп. к обычно имеющейся инфраструктуре)"
                v-model="equipmentCost"
              />
              <v-text-field
                label="Стоимость приобретения расходных материалов"
                v-model="consumablesCost"
              />
              <v-text-field
                label="Стоимость подготовки кадров"
                v-model="personnelCost"
              />
              <v-text-field
                label="Стоимость подготовки целевых аудиторий"
                v-model="targetAudiencesCost"
              />
              <v-text-field
                label="Стоимость приобретения информационных ресурсов"
                v-model="resourcesCost"
              />
              <v-select
                label="Участники"
                v-model="participant"
                :items="dict24"
                multiple
                chips
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Целевые аудитории"
                v-model="targetAudiences"
                :items="dict25"
                multiple
                chips
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Отраслевая направленность"
                v-model="branchOrientation"
                :items="dict27"
                item-value="code"
                item-text="value"
              />

              <v-select
                label="Возможный уровень внедрения"
                v-model="possibleLevel"
                :items="dict29"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Реальность применения"
                v-model="applicationReality"
                :items="dict30"
                item-value="code"
                item-text="value"
              />
              <v-textarea
                label="Опыт практического применения"
                v-model="applicationExperience"
                rows="1"
                auto-grow
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-2"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="end">
              <the-chapter-two-score @change-invalid="emit">
              </the-chapter-two-score>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple color="teal lighten-2">
          Критерии эффективности применения/полезности (раздел 3)
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Ограничения использования ИТЗ"
                v-model="limitations"
                :items="dict33"
                item-value="code"
                item-text="value"
              />
              <v-select
                label="Удобство применения ИТЗ"
                v-model="usability"
                :items="dict34"
                item-value="code"
                item-text="value"
              />
              <v-row>
                <v-col cols="6">
                  <div class="text-subtitle-1">Медицинская эффективность</div>
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="medicalEffectiveness"
                    min="0"
                    max="1"
                    step="0.1"
                    ticks
                    thumb-label="always"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <div class="text-subtitle-1">Социальная эффективность</div>
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="socialEffectiveness"
                    min="0"
                    max="1"
                    step="0.1"
                    ticks
                    thumb-label="always"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <div class="text-subtitle-1">Экономическая эффективность</div>
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="economicEffectiveness"
                    min="0"
                    max="1"
                    step="0.1"
                    ticks
                    thumb-label="always"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <div class="text-subtitle-1">Ценность ИТЗ</div>
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="usefulness"
                    min="0"
                    max="1"
                    step="0.1"
                    ticks
                    thumb-label="always"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-divider v-if="expert" vertical class="mx-4"></v-divider>
            <v-col v-if="expert"> </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header ripple color="teal lighten-1">
          Доказательная база (клинические исследования и апробация)
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-textarea
                label="Учреждение"
                v-model="organization"
                rows="1"
                auto-grow
              />
              <v-select
                label="Обоснование статистической модели исследования"
                v-model="modelJustification"
                :items="dict36"
                item-value="code"
                item-text="value"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-select
                label="Клинические исследования и апробация"
                v-model="test"
                :items="dict13"
                item-value="code"
                item-text="value"
              />
            </v-col>
            <v-divider v-if="expert" vertical class="ma-4"></v-divider>
            <v-col v-if="expert" :class="expertModeColor" align-self="end">
              <the-test-score></the-test-score>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="expertModeCols">
              <v-row>
                <v-col cols="6">
                  <v-select
                    label="Протокол исследования"
                    v-model="protocol"
                    :items="dict10"
                    item-value="code"
                    item-text="value"
                  />
                </v-col>
                <v-col cols="6">
                  <v-file-input />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select
                    label="Опросники исследования"
                    v-model="inventory"
                    :items="dict11"
                    item-value="code"
                    item-text="value"
                  />
                </v-col>
                <v-col cols="6">
                  <v-file-input />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select
                    label="Рассмотрение на Этическом комитете"
                    v-model="ethicsСomm"
                    :items="dict12"
                    item-value="code"
                    item-text="value"
                  />
                </v-col>
                <v-col cols="6">
                  <v-file-input />
                </v-col>
              </v-row>
            </v-col>
            <v-divider v-if="expert" vertical class="mx-4"></v-divider>
            <v-col v-if="expert"> </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";
import { required } from "vuelidate/lib/validators";

import AttachedFiles from "@/components/AttachedFiles.vue";
import TheLawsScore from "./scores/TheLawsScore.vue";
import TheTargetScore from "./scores/TheTargetScore.vue";
import TheChapterOneScore from "./scores/TheChapterOneScore.vue";
import TheLegalProtectionScore from "./scores/TheLegalProtectionScore.vue";
import ThePriorityScore from "./scores/ThePriorityScore.vue";
import TheFinancingScore from "./scores/TheFinancingScore.vue";
import TheTestScore from "./scores/TheTestScore.vue";
import TheChapterTwoScore from "./scores/TheChapterTwoScore.vue";

export default {
  name: "ExpertCard",
  components: {
    AttachedFiles,
    TheLawsScore,
    TheTargetScore,
    TheChapterOneScore,
    TheLegalProtectionScore,
    ThePriorityScore,
    TheFinancingScore,
    TheTestScore,
    TheChapterTwoScore,
  },
  props: {
    id: { type: Number, required: true },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  validations: {
    application: { required },
    name: { required },
  },
  data: () => ({
    expert: true,
    year: [
      "до 2010",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    maturityLevels: [
      { code: "1", value: "Идея (TRL 1-3)" },
      { code: "2", value: "Технология (TRL 4-5)" },
      { code: "3", value: "Модель/Прототип (TRL 6-7)" },
      { code: "4", value: "Продукт (TRL 8-9)" },
    ],
    technologyCharacters: [
      { code: "1", value: "информационная (программная)" },
      { code: "2", value: "программно-аппаратная" },
      { code: "3", value: "инструментальная (аппаратная)" },
      { code: "4", value: "организационно-методическая" },
    ],
    hsClassifier: [
      { code: "1", value: "Drug Discovery and Research" },
      { code: "2", value: "Medical Imaging and Diagnostics" },
      { code: "3", value: "Clinical Decision Support System" },
      { code: "4", value: "Predictive Insight and Risk Analytics" },
      { code: "5", value: "Lifestyle Management and Monitoring" },
      { code: "6", value: "Wearables/Sensor Data Insight" },
      { code: "7", value: "Chronic Condition Management" },
      { code: "8", value: "Virtual Assistance" },
      { code: "9", value: "Mental Health" },
      { code: "10", value: "Emergency Room and Surgery" },
    ],
    panels: [0],
  }),

  computed: {
    ...mapGetters({
      card: GETTERS.CARD_DATA,
      dict4: GETTERS.DICTIONARY_4,
      dict5: GETTERS.DICTIONARY_5,
      dict6: GETTERS.DICTIONARY_6,
      dict7: GETTERS.DICTIONARY_7,
      dict8: GETTERS.DICTIONARY_8,
      dict10: GETTERS.DICTIONARY_10,
      dict11: GETTERS.DICTIONARY_11,
      dict12: GETTERS.DICTIONARY_12,
      dict13: GETTERS.DICTIONARY_13,
      dict14: GETTERS.DICTIONARY_14,
      dict17: GETTERS.DICTIONARY_17,
      dict18: GETTERS.DICTIONARY_18,
      dict19: GETTERS.DICTIONARY_19,
      dict20: GETTERS.DICTIONARY_20,
      dict21: GETTERS.DICTIONARY_21,
      dict22: GETTERS.DICTIONARY_22,
      dict24: GETTERS.DICTIONARY_24,
      dict25: GETTERS.DICTIONARY_25,
      dict26: GETTERS.DICTIONARY_26,
      dict27: GETTERS.DICTIONARY_27,
      dict28: GETTERS.DICTIONARY_28,
      dict29: GETTERS.DICTIONARY_29,
      dict30: GETTERS.DICTIONARY_30,
      dict33: GETTERS.DICTIONARY_33,
      dict34: GETTERS.DICTIONARY_34,
      dict36: GETTERS.DICTIONARY_36,
      dict100: GETTERS.DICTIONARY_100,
      dict101: GETTERS.DICTIONARY_101,
      dict102: GETTERS.DICTIONARY_102,
      dict103: GETTERS.DICTIONARY_103,
      getDictionaryItem: GETTERS.DICTIONARY_ITEM,
    }),

    expertModeCols() {
      return this.expert ? 8 : 12;
    },
    expertModeColor() {
      return "";
      // return "grey lighten-1";
    },

    laws: {
      get() {
        return this.card.laws;
      },
      set(value) {
        this.modify({ laws: value });
      },
    },
    controlOrientation: {
      get() {
        return this.card.controlOrientation;
      },
      set(value) {
        this.modify({ controlOrientation: value });
      },
    },
    factorOrientation: {
      get() {
        return this.card.factorOrientation;
      },
      set(value) {
        this.modify({ factorOrientation: value });
      },
    },
    target: {
      get() {
        return this.card.target;
      },
      set(value) {
        this.modify({ target: value });
      },
    },

    application: {
      get() {
        return this.card.application;
      },
      set(value) {
        this.modify({ application: value });
      },
    },
    applicationErrors() {
      const errors = [];
      if (!this.$v.application.required) {
        errors.push("заполните обязательное поле!");
      }
      return errors;
    },

    uNumber() {
      return this.card.uNumber;
    },
    name: {
      get() {
        return this.card.name;
      },
      set(value) {
        this.modify({ name: value });
      },
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.required) {
        errors.push("заполните обязательное поле!");
      }
      return errors;
    },

    infoSource: {
      get() {
        return this.card.infoSource;
      },
      set(value) {
        this.modify({ infoSource: value });
      },
    },
    creationYear: {
      get() {
        return this.card.creationYear;
      },
      set(value) {
        this.modify({ creationYear: value });
      },
    },
    infoSourceFiles: {
      get() {
        return this.card.infoSourceFiles;
      },
      set(value) {
        this.modify({ infoSourceFiles: value });
      },
    },
    description: {
      get() {
        return this.card.description;
      },
      set(value) {
        this.modify({ description: value });
      },
    },
    technologyCharacter: {
      get() {
        return this.card.technologyCharacter;
      },
      set(value) {
        this.modify({ technologyCharacter: value });
      },
    },
    maturityLevel: {
      get() {
        return this.card.maturityLevel;
      },
      set(value) {
        this.modify({ maturityLevel: value });
      },
    },
    healthcareClassifier: {
      get() {
        return this.card.healthcareClassifier;
      },
      set(value) {
        this.modify({ healthcareClassifier: value });
      },
    },
    profiles: {
      get() {
        return this.card.profiles;
      },
      set(value) {
        this.modify({ profiles: value });
      },
    },
    protocol: {
      get() {
        return this.card.protocol;
      },
      set(value) {
        this.modify({ protocol: value });
      },
    },
    inventory: {
      get() {
        return this.card.inventory;
      },
      set(value) {
        this.modify({ inventory: value });
      },
    },
    ethicsСomm: {
      get() {
        return this.card.ethicsСomm;
      },
      set(value) {
        this.modify({ ethicsСomm: value });
      },
    },
    test: {
      get() {
        return this.card.test;
      },
      set(value) {
        this.modify({ test: value });
      },
    },
    legalProtection: {
      get() {
        return this.card.legalProtection;
      },
      set(value) {
        this.modify({ legalProtection: value });
      },
    },
    financing: {
      get() {
        return this.card.financing;
      },
      set(value) {
        this.modify({ financing: value });
      },
    },
    investmentPeriod: {
      get() {
        return this.card.investmentPeriod;
      },
      set(value) {
        this.modify({ investmentPeriod: value });
      },
    },
    developers: {
      get() {
        return this.card.developers;
      },
      set(value) {
        this.modify({ developers: value });
      },
    },
    rewards: {
      get() {
        return this.card.rewards;
      },
      set(value) {
        this.modify({ rewards: value });
      },
    },
    priority: {
      get() {
        return this.card.priority;
      },
      set(value) {
        this.modify({ priority: value });
      },
    },
    personnel: {
      get() {
        return this.card.personnel;
      },
      set(value) {
        this.modify({ personnel: value });
      },
    },
    specifications: {
      get() {
        return this.card.specifications;
      },
      set(value) {
        this.modify({ specifications: value });
      },
    },
    consumables: {
      get() {
        return this.card.consumables;
      },
      set(value) {
        this.modify({ consumables: value });
      },
    },
    hstCost: {
      get() {
        return this.card.hstCost;
      },
      set(value) {
        this.modify({ hstCost: value });
      },
    },
    equipmentCost: {
      get() {
        return this.card.equipmentCost;
      },
      set(value) {
        this.modify({ equipmentCost: value });
      },
    },
    consumablesCost: {
      get() {
        return this.card.consumablesCost;
      },
      set(value) {
        this.modify({ consumablesCost: value });
      },
    },
    personnelCost: {
      get() {
        return this.card.personnelCost;
      },
      set(value) {
        this.modify({ personnelCost: value });
      },
    },
    targetAudiencesCost: {
      get() {
        return this.card.targetAudiencesCost;
      },
      set(value) {
        this.modify({ targetAudiencesCost: value });
      },
    },
    resourcesCost: {
      get() {
        return this.card.resourcesCost;
      },
      set(value) {
        this.modify({ resourcesCost: value });
      },
    },
    participant: {
      get() {
        return this.card.participant;
      },
      set(value) {
        this.modify({ participant: value });
      },
    },
    targetAudiences: {
      get() {
        return this.card.targetAudiences;
      },
      set(value) {
        this.modify({ targetAudiences: value });
      },
    },
    levels: {
      get() {
        return this.card.levels;
      },
      set(value) {
        this.modify({ levels: value });
      },
    },
    branchOrientation: {
      get() {
        return this.card.branchOrientation;
      },
      set(value) {
        this.modify({ branchOrientation: value });
      },
    },
    subjectOrientations: {
      get() {
        return this.card.subjectOrientations;
      },
      set(value) {
        this.modify({ subjectOrientations: value });
      },
    },
    possibleLevel: {
      get() {
        return this.card.possibleLevel;
      },
      set(value) {
        this.modify({ possibleLevel: value });
      },
    },
    applicationReality: {
      get() {
        return this.card.applicationReality;
      },
      set(value) {
        this.modify({ applicationReality: value });
      },
    },
    applicationExperience: {
      get() {
        return this.card.applicationExperience;
      },
      set(value) {
        this.modify({ applicationExperience: value });
      },
    },
    limitations: {
      get() {
        return this.card.limitations;
      },
      set(value) {
        this.modify({ limitations: value });
      },
    },
    usability: {
      get() {
        return this.card.usability;
      },
      set(value) {
        this.modify({ usability: value });
      },
    },
    medicalEffectiveness: {
      get() {
        return this.card.medicalEffectiveness;
      },
      set(value) {
        this.modify({ medicalEffectiveness: value });
      },
    },
    socialEffectiveness: {
      get() {
        return this.card.socialEffectiveness;
      },
      set(value) {
        this.modify({ socialEffectiveness: value });
      },
    },
    economicEffectiveness: {
      get() {
        return this.card.economicEffectiveness;
      },
      set(value) {
        this.modify({ economicEffectiveness: value });
      },
    },
    usefulness: {
      get() {
        return this.card.usefulness;
      },
      set(value) {
        this.modify({ usefulness: value });
      },
    },
    organization: {
      get() {
        return this.card.organization;
      },
      set(value) {
        this.modify({ organization: value });
      },
    },
    modelJustification: {
      get() {
        return this.card.modelJustification;
      },
      set(value) {
        this.modify({ modelJustification: value });
      },
    },
    invalid() {
      return this.$v.$invalid;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
    formatTree(idx, code) {
      const item = this.getDictionaryItem(idx, code);
      return item ? `${item.code} ${item.value}` : "";
    },

    emit(value) {
      this.$emit("change-invalid", value);
    },
  },
  watch: {
    invalid(value) {
      this.$emit("change-invalid", value);
    },
  },
};
</script>
